import React, { FC, memo } from 'react';
import LanguageSelect from 'Component/pages/components/LanguageSelect';
import { AsrFilterConfig } from 'src/api/types';
import { SecondaryTypeMap } from '../../const';
import { SelectProps } from 'antd';

interface TemplateProps {
    sourceType: number;
    value?: AsrFilterConfig;
    onChange?: (v: TemplateProps['value']) => void;
    options?: SelectProps<number>['options'];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { sourceType, value, onChange, options } = props;

    return (
        <LanguageSelect
            value={value?.filter?.languageType}
            onChange={(v) =>
                onChange?.({
                    type: 1,
                    sourceType,
                    activeFlag: 1,
                    secondaryType: SecondaryTypeMap.LANG,
                    ...value,
                    filter: { ...value?.filter, languageType: v as number },
                })
            }
            style={{ width: 300 }}
            options={options}
        />
    );
});

export default Template;
